import React from 'react'
import { AppDownload } from '@pcln/vip'
import analytics from '@/shared-utils/analytics'

type AppDownloadWrapperProps = {
  category: string
}

const AppDownloadWrapper = ({
  category,
  ...props
}: AppDownloadWrapperProps & Record<string, unknown>) => {
  const gaAppDownload = (device: string) => {
    analytics.fireEvent({
      action: 'app download',
      category,
      label: device
    })
  }

  return <AppDownload gaTracking={gaAppDownload} {...props} />
}

export default AppDownloadWrapper
